import React from "react";

import Header from "../../Components/LAST Page/Header-last";
import Hero from "../../Components/LAST Page/Hero";
import FullDetails from "../../Components/LAST Page/fulldetails";
import Statistics from "../../Components/LAST Page/Statistics";
import Gallery from "../../Components/LAST Page/Gallery";
import Events from "../../Components/LAST Page/Events";
import Reviews from "../../Components/LAST Page/Reviews";
import PlacementStatistics from "../../Components/LAST Page/PlacementStats";
import EmployeeDirectory from "../../Components/LAST Page/EmployeeDirectory";
import SocialMedia from "../../Components/LAST Page/SocialMedia";
import NoticeBoard from "../../Components/LAST Page/NoticeBoard";
import ExamPortal from "../../Components/LAST Page/ExamPortal";
import JobApplication from "../../Components/LAST Page/JobApplication";
import FAQ from "../../Components/LAST Page/FAQ";
import Location from "../../Components/LAST Page/Location";
import ContactSupport from "../../Components/LAST Page/ContactSupport";
import Footer from "../../Components/LAST Page/Footer";

import SocialLinks from "../../Components/LAST Page/SocialMedia";
const Lastpage = () => {
  return (
    <>
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <Hero />

      {/* Social Connections */}
      <SocialLinks />

      {/* Find Us / Live Location */}
      <Location />

      {/* Footer */}
      <Footer />

    </>
  );
};

export default Lastpage;